 
import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../services/admin/admin.service';

@Component({
  selector: 'app-admin-customers',
  templateUrl: './admin-customers.component.html',
  styleUrls: ['./admin-customers.component.scss']
})
export class AdminCustomersComponent implements OnInit {

  // =========================================================
  // Customer List
  // =========================================================

  rows: any[] = [];

  showDialog: boolean = false;

  editor: any = {};

  editorFields: any[] = [
    { name: 'userId', label: 'ID' },
    { name: 'firstName', label: 'First Name' },
    { name: 'lastName', label: 'Last Name' },
    { name: 'email', label: 'Email' }
  ];


  // =========================================================
  // Pagination
  // =========================================================

  currentPage: number = 1;

  pageSize: number = 10;


  // =========================================================
  // Constructor
  // =========================================================

  constructor(
    private adminService: AdminService
  ) { }


  // =========================================================
  // Init
  // =========================================================

  ngOnInit(): void {

    this.loadPageData();

  }


  // =========================================================
  // Load Customers
  // =========================================================

  loadPageData(): void {

    this.adminService
      .getCustomers()
      .subscribe({

        next: (response: any) => {

          this.rows = Array.isArray(response)
            ? response
            : [];

          this.validateCurrentPage();

        },

        error: (error: any) => {

          console.error(
            'Error loading customers:',
            error
          );

          this.rows = [];

          this.currentPage = 1;

        }

      });

  }


  // =========================================================
  // Add Customer
  // =========================================================

  openNew(): void {

    this.editor = {};

    this.showDialog = true;

  }


  // =========================================================
  // Edit Customer
  // =========================================================

  edit(row: any): void {

    this.editor = { ...row };

    this.showDialog = true;

  }


  // =========================================================
  // Save Customer
  // =========================================================

  save(): void {

    this.adminService
      .saveCustomer(this.editor)
      .subscribe(() => {

        this.showDialog = false;

        this.loadPageData();

      });

  }


  // =========================================================
  // Pagination
  // =========================================================

  // Get paginated customers
  get pagedCustomers(): any[] {

    const startIndex =
      (this.currentPage - 1) * this.pageSize;

    return this.rows.slice(
      startIndex,
      startIndex + this.pageSize
    );

  }


  // Total pages
  get totalPages(): number {

    return Math.max(
      1,
      Math.ceil(
        this.rows.length / this.pageSize
      )
    );

  }


  // Page numbers
  get pageNumbers(): number[] {

    return Array.from(
      { length: this.totalPages },
      (_, index) => index + 1
    );

  }


  // First displayed record
  get startRecord(): number {

    if (this.rows.length === 0) {
      return 0;
    }

    return (
      (this.currentPage - 1) * this.pageSize
    ) + 1;

  }


  // Last displayed record
  get endRecord(): number {

    return Math.min(
      this.currentPage * this.pageSize,
      this.rows.length
    );

  }


  // Change current page
  changePage(page: number): void {

    if (
      !Number.isInteger(page) ||
      page < 1 ||
      page > this.totalPages
    ) {
      return;
    }

    this.currentPage = page;

  }


  // Previous page
  previousPage(): void {

    this.changePage(
      this.currentPage - 1
    );

  }


  // Next page
  nextPage(): void {

    this.changePage(
      this.currentPage + 1
    );

  }


  // Change page size
  onPageSizeChange(): void {

    this.currentPage = 1;

  }


  // Validate current page after loading data
  private validateCurrentPage(): void {

    this.currentPage = Math.max(
      1,
      Math.min(
        this.currentPage,
        this.totalPages
      )
    );

  }

}
